import React, {useState} from "react";
import {Button, Checkbox, Col, Form, Input, PageHeader, Radio, Row, Select, Tabs} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import {PSA_INSTANCE, VALID_PROJECT_CODE} from "../Constants";
import {d365ProjectSearch} from "../../api/d365Api";
import {handleResponse} from "./utils";
import {ProjectSearchExportsTab} from "./ProjectSearchExportsTab";
import {ProjectSearchRatesTab} from "./ProjectSearchRatesTab";
import {ProjectSearchHourLogTab} from "./ProjectSearchHourLogTab";
import {ProjectSearchUnfoundProjectsTab} from "./ProjectSearchUnfoundProjectsTab";
import './ProjectSearch.css'
import {ProjectSearchMessagesTab} from "./ProjectSearchMessagesTab";
import {ProjectSearchProjectorTab} from "./ProjectSearchProjectorTab";

global.ASYNC_VALIDATOR_NO_WARNING = 1;

const ProjectSearch = () => {
  const FORM_PROJECT_CODE = 'projectCode';

  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [exports, setExports] = useState([]);
  const [ratesResponse, setRatesResponse] = useState([]);
  const [hourLog, setHourLog] = useState([]);
  const [unfoundProjects, setUnfoundProjects] = useState([]);
  const [messages, setMessages] = useState([]);
  const [project, setProject] = useState({});
  const [activeKey, setActiveKey] = useState('1');
  const [includeIncomplete, setIncludeIncomplete] = useState(false);
  const [psaInstance, setPsaInstance] = useState('CREDERA');

  const handleCheckbox = (t) => {
    setIncludeIncomplete(t.target.checked)
  }
  const project_search = async () => {
    setLoading(true);
    const response = await d365ProjectSearch(
      form.getFieldValue(FORM_PROJECT_CODE),
      includeIncomplete,
      psaInstance
      );
    handleResponse(response, 'Project Search', 'data collection');
    try {
      if (response.ok) {
        response.json().then(r => {
          setExports(r.exports);
          setRatesResponse(r.rates);
          setHourLog(r.hourLog);
          setUnfoundProjects(r.unfoundProjects);
          setMessages(r.msg);
          setProject(r.ProjectElement);
        });
      }
    } catch (e) {
      console.error('Could not get project search data');
    } finally {
      setLoading(false);
    }
  }

  const items = [
    {
      key: '1',
      children: (<ProjectSearchExportsTab
        exports={exports}
        loading={loading}
      />)
    }, {
      key: '2',
      children: (<ProjectSearchRatesTab
        ratesResponse={ratesResponse}
        loading={loading}
      />)
    }, {
      key: '3',
      children: (<ProjectSearchHourLogTab
        hourLog={hourLog}
        loading={loading}
      />)
    }, {
      key: '4',
      children: (<ProjectSearchUnfoundProjectsTab
        unfoundProjects={unfoundProjects}
        loading={loading}
      />)
    }, {
      key: '5',
      children: (<ProjectSearchProjectorTab
        project={project}
        loading={loading}
      />)
    }, {
      key: '6',
      children: (<ProjectSearchMessagesTab
        messages={messages}
        loading={loading}/>)
    },
  ];

  const onChange = (e) => {
    setActiveKey(e.target.value);
  }

  return (
    <>
      <Row>
        <Col span={12}>
          <PageHeader
            title="Project Search"
            style={{padding: 0}}
          />
        </Col>
      </Row>
      <Row style={{marginBottom: 10}}>
        <Col span={16} style={{marginRight: 10}}>
          <Form
            name={'project_search'}
            form={form}
            layout="inline"
            onFinish={project_search}
          >
            <Form.Item
              label="Projector"
              tooltip={
                "Indicate the Projector PSA Instance for your search. "
              }
              rules={[{required: true, message: "Please select Psa Instance"}]}
            >
              <Select
                style={{width: 120}}
                value={psaInstance}
                onChange={setPsaInstance}
                placeholder="Select Psa Instance"
                options={PSA_INSTANCE}
              />
            </Form.Item>
            <Form.Item
              label='Project Code'
              name={FORM_PROJECT_CODE}
              rules={[{required: true, pattern: VALID_PROJECT_CODE, message: 'Incorrect Project Code'}]}
            >
              <Input
                style={{maxWidth: 200}}
                placeholder="Enter project code"
                disabled={loading}
                allowClear
              />
            </Form.Item>
            <Checkbox
              onChange={handleCheckbox}
              disabled={loading}
            >Include incomplete
            </Checkbox>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                icon={<SearchOutlined/>}
              >
                Search
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
      <Radio.Group onChange={onChange} disabled={loading} defaultValue="1">
        <table>
          <thead style={{height: 20, fontSize: 12}}>
          <tr>
            <th>
              Exports Rates & Hours
            </th>
            <th>&nbsp;&nbsp;&nbsp;</th>
            <th>Expenses</th>
            <th>&nbsp;&nbsp;&nbsp;</th>
            <th>Projector</th>
            <th>&nbsp;&nbsp;&nbsp;</th>
            <th>Project Search</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <Radio.Button value="1">Exports</Radio.Button>
              <Radio.Button value="2">Rates</Radio.Button>
              <Radio.Button value="3">Hour&nbsp;Log</Radio.Button>
            </td>
            <td></td>
            <td>
              <Radio.Button value="4">Unfound&nbsp;Projects</Radio.Button>
            </td>
            <td></td>
            <td>
              <Radio.Button value="5">Project</Radio.Button>
            </td>
            <td></td>
            <td>
              <Radio.Button value="6">Messages</Radio.Button>
            </td>
          </tr>
          </tbody>
        </table>
      </Radio.Group>
      <Tabs
        id="project-search-tabs"
        defaultActiveKey="1"
        activeKey={activeKey}
        items={items}
        size="small"
      />

    </>
  );
}

export {ProjectSearch};